import { Button, Link, Text } from '@chakra-ui/react'
import { Lato14ExtendedRegular, Lato16Bold } from '@sequencehq/design-tokens'
import { PageContainer } from 'modules/LoginApp/components/common/PageContainer'
import { Section } from 'modules/LoginApp/components/common/Section'
import { getDashboardDomain } from 'modules/LoginApp/helpers'
import { Wordmark } from '@sequencehq/core-components'
import { isProductionEnv } from 'lib/environment/environment'

export const NoWorkspacePage = () => {
  const targetEnvironment = isProductionEnv() ? 'sandbox' : 'production'
  const targetUrl = `https://${getDashboardDomain(
    targetEnvironment
  )}/auth/login`

  return (
    <PageContainer>
      <Wordmark width="126" height="26.74" />
      <Section gap="8px">
        <Text {...Lato16Bold} color="gray.90">
          You’re not part of a workspace
        </Text>
        <Text {...Lato14ExtendedRegular} color="gray.80">
          The email address you provided is not currently associated with any
          workspace in this environment. Please contact your administrator or
          try signing in with a different email.
        </Text>
        <Button
          as={Link}
          href="/auth/login"
          mt="2"
          variant="primary2"
          width="100%"
          _hover={{
            textDecoration: 'none'
          }}
        >
          Try again
        </Button>
        <Button
          as={Link}
          href={targetUrl}
          variant="secondary2"
          width="100%"
          _hover={{
            textDecoration: 'none'
          }}
        >
          Try again in {targetEnvironment}
        </Button>
      </Section>
      <Text position="absolute" bottom="40px" textAlign="center" zIndex={10}>
        New to Sequence? <Link color="indigo.50">Request access</Link>
      </Text>
    </PageContainer>
  )
}

export default NoWorkspacePage
